export interface ILocalization{
    Add: string;
    AllRoles: string;
    FilterByGroup: string;
    GlobalRoles: string;
    Role: string;
    RolePermissions: string;
    SelectRole: string;
    User: string;
    UserPermissions: string;
};